var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Grid, Select } from 'semantic-ui-react';
import FieldWithErrorDisplay from "../../FieldWithErrorDisplay";
var SelectSampleTypeForm = /** @class */ (function (_super) {
    __extends(SelectSampleTypeForm, _super);
    function SelectSampleTypeForm(props) {
        var _this = _super.call(this, props) || this;
        _this.sampleTypeOptions = function () {
            // todo pass in different lists of sample types based on the store page?
            var nonIncludedSampleTypes = _this.props.manualPro ?
                _this.props.sampleTypes.filter(function (s) {
                    return s.id === 'CELLS_SUSPENSION' || s.id === 'NORTHERN_BLOT';
                }).map(function (s) { return s.id; }) : [];
            return _this.props.sampleTypes
                .filter(function (s) { return !nonIncludedSampleTypes.includes(s.id); })
                .map(function (t) { return ({
                text: t.label,
                value: t.id
            }); });
        };
        _this.onSampleTypeChange = function (event, data) {
            var val = _this.props.sampleTypes.find(function (v) { return v.id === data.value; });
            if (val === undefined) {
                throw new RangeError("Could not find sample type " + data.value);
            }
            var prevSampleType = _this.props.sampleTypeState.sampleType;
            var update = { sampleType: val };
            _this.props.onSampleTypeChange(update, prevSampleType, _this.props.onUserSelection);
        };
        return _this;
    }
    SelectSampleTypeForm.prototype.render = function () {
        return React.createElement(Grid, { columns: 4, stackable: true, textAlign: "left" },
            React.createElement(Grid.Row, null,
                React.createElement(Grid.Column, { textAlign: "left" },
                    React.createElement(FieldWithErrorDisplay, { errors: this.props.errors, errorPath: '/sampleType', labelContent: "", showErrors: this.props.showErrors },
                        React.createElement(Select, { className: "wide-dropdown", options: this.sampleTypeOptions(), onChange: this.onSampleTypeChange, placeholder: "Select...", selectOnNavigation: false, selectOnBlur: false, value: this.props.sampleTypeState.sampleType.id })))));
        /**
         * Implementation of sample type selection as buttons instead of dropdown
         */
        // return <Grid columns={4} stackable={true} textAlign={"left"}>
        //     <Grid.Row>
        //         {this.sampleTypeOptions().map((b, index) => {
        //             return <React.Fragment key={index}>
        //                 <Grid.Column width={3} key={index} textAlign={"left"}>
        //                     <Button
        //                         className={this.props.sampleTypeState.sampleType?.id === b.value ? "sample-type-box selected-sample-type" : "sample-type-box"}
        //                         fluid={true}
        //                         tabIndex={b.value}
        //                         onClick={this.onSampleTypeChange}
        //                     >
        //                         <p>{b.text}</p>
        //                     </Button>
        //                 </Grid.Column>
        //             </React.Fragment>
        //         })}
        //     </Grid.Row>
        // </Grid>;
    };
    return SelectSampleTypeForm;
}(React.PureComponent));
export default SelectSampleTypeForm;
//# sourceMappingURL=SelectSampleTypeForm.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/rna-fish/SelectSampleTypeForm.js
// module id = 180
// module chunks = 0